// Currency Chnage

const moneyInterval = setInterval(() => {
  const money = document.querySelectorAll('.money');
  money.forEach((div) => {
    const moneyText = div.innerText;
    div.innerText = moneyText.replace('Rs.', 'PKR ');
  });
}, 50);

// setTimeout(() => {
//   clearInterval(moneyInterval);
// }, 5000);